export const getStatusColor = (value: number | null, threshold: number) => {
    if (value === null || Number.isNaN(value) || !Number.isFinite(value)) {
        return "lightgray";
    }
    if (value < threshold / 2) {
        return "lightgreen";
    }
    if (value < threshold) {
        return "khaki";
    }
    return "lightcoral";
};

export const formatValue = (value: number | null) => {
    if (value === null || Number.isNaN(value) || !Number.isFinite(value)) {
        return "NaN";
    }
    return `${value.toFixed(2)}%`;
};

